{
  "welcome": "Welcome",
  "divider": "– OR –",
  "continue": "Continue",
  "checkEmailTitle": "Check your email",
  "emailLinkSent": "Check your email — we’ve sent you a link that signs you in.",
  "spamHint": "If you don’t receive an email please check your spam folder or <retryLink>try again</retryLink> in 5 minutes.",
  "terms": "By continuing, you agree to the <termsLink>Terms of Service</termsLink> and acknowledge the <privacyLink>Privacy Policy</privacyLink>.",
  "loginLinkOffer": "Email me a sign-in link instead",
  "didYouMean": "Did you mean <suggestionButton>{{suggestion}}</suggestionButton>?",
  "verifyPrompt": "In order to activate your account, you need to verify your email address. You may request a new confirmation email.",
  "verificationRequiredTitle": "Confirm your email to continue",
  "verificationRequiredBody": "We sent a confirmation link to {{email}}. Please open it to carry on using Profiling.app.",
  "verificationWrongAddress": "Wrong address? Change it",
  "changeEmail": "Change Email",
  "changePassword": "Change password",
  "myAccount": "My Account",
  "nameWorkspace": "Name your workspace",
  "emailVerified": "Your email address has been verified.",
  "emailVerifyError": "Email verification failed. Please try again.",
  "signedIn": "You are signed in.",
  "loginLinkError": "This sign-in link is invalid or has expired.",
  "accountCreated": "New account created for {{email}}. We’ve emailed you a verification link.",
  "socialError": "Authentication failed.",
  "verificationEmailSent": "Verification email sent.",
  "emailPlaceholder": "Email",
  "passwordPlaceholder": "Password",
  "passwordHelper": "Your password — or pick one to sign up. Leave blank and we’ll email you a sign-in link."
}
